import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteMotivoDeCancelacion,
  getMotivosDeCancelacion,
  patchMotivoDeCancelacion,
  postMotivoDeCancelacion,
} from 'api/pae/motivosDeCancelacion';
import { capitalize } from 'utils/normalizers';

export const permissionConfig = {
  permissionModel: 'motivodecancelacionpae',
};

// eslint-disable-next-line react/prop-types
const MotivosDeCancelacion = ({ permission }) => (
  <PlainCRUD
    title="Motivo de Cancelación"
    get={getMotivosDeCancelacion}
    post={postMotivoDeCancelacion}
    patch={patchMotivoDeCancelacion}
    delete={deleteMotivoDeCancelacion}
    permission={permission}
    disabledStateField
    tableProps={{
      allowColumnSelector: false,
      deleteText: 'Cancelar',
    }}
    fields={[
      {
        ...defaultFields.descripcion,
        normalize: (value) => capitalize(value),
      },
    ]}
  />
);

export default MotivosDeCancelacion;
